import { STATUS_CODE, STATUS_MESSAGE } from './constants.js';

/**
 * Error thrown by SFTP operations.
 * Carries the SFTP status code from the server response.
 */
export class SftpError extends Error {
	readonly code: number;
	readonly serverMessage: string;

	constructor(code: number, serverMessage?: string) {
		const label = STATUS_MESSAGE[code] ?? `Unknown status ${code}`;
		const msg = serverMessage && serverMessage !== label ? `${label}: ${serverMessage}` : label;
		super(msg);
		this.name = 'SftpError';
		this.code = code;
		this.serverMessage = serverMessage ?? label;
	}

	get isEof(): boolean {
		return this.code === STATUS_CODE.EOF;
	}

	get isNoSuchFile(): boolean {
		return this.code === STATUS_CODE.NO_SUCH_FILE;
	}

	get isPermissionDenied(): boolean {
		return this.code === STATUS_CODE.PERMISSION_DENIED;
	}
}
